module.exports = __webpack_public_path__ + "img/library-logo-pink.d98213a1.svg";